import React,{useRef, useState} from "react";
import { Link } from "react-scroll";
// import { IoMenu } from "react-icons/io5";
// import { RxCross2 } from "react-icons/rx";
import "./header.css"
function Header(){
    const [menu,setMenu] = useState("Home");
    const menuRef=useRef();
    const openMenu=()=>{
        menuRef.current.style.right="0";
    }
    const closeMenu=()=>{
        menuRef.current.style.right="-350px";
    }
    return (
        <div className="mainHead">
           <div className="mainHeadLogo"><img src="/images/Roshan.png" alt="" /></div>
            <img src="/images/menu.png" alt="" className="headOpen" onClick={openMenu}/>
            <ul ref={menuRef} className="optionDiv">
                <img src="/images/cross.png" alt="" className="headClose" onClick={closeMenu}/>
                <li><Link to="Home" smooth={true} duration={500}><p onClick={()=>setMenu("Home")}>Home</p></Link>{menu==="Home"?<img src="/images/back.png" alt=""></img>:<></>}</li>
                <li><Link to="About" smooth={true} duration={500}><p onClick={()=>setMenu("About Me")}>About Me</p></Link>{menu==="About Me"?<img src="/images/back.png" alt=""></img>:<></>}</li>
                <li><Link to="Services" smooth={true} duration={500}><p onClick={()=>setMenu("Services")}>Services</p></Link>{menu==="Services"?<img src="/images/back.png" alt=""></img>:<></>}</li>
                <li><Link to="Work" smooth={true} duration={500}><p onClick={()=>setMenu("Portfolia")}>projects</p></Link>{menu==="Portfolia"?<img src="/images/back.png" alt=""></img>:<></>}</li>
                <li><Link to="Contact" smooth={true} duration={500}><p onClick={()=>setMenu("Contact")}>Contact</p></Link>{menu==="Contact"?<img src="/images/back.png" alt=""></img>:<></>}</li>
            </ul>
            <Link to="Contact" smooth={true} duration={500}><div className="headConnect">
                Connect With Me
            </div></Link>
        </div>
    )
}
export default Header;
